import axios from "axios";
import { API_BASE_URL1 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");

const getToken = () => {
    return localStorage.getItem("token");
  };



export const AllCompanyDetails = async () => {
    try {
      const response = await axios.get( API_BASE_URL1 +`company/get`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };

  export const CreateCompanyDetails = async (companyData) => {
    try {
      const response = await axios.post( API_BASE_URL1 +`company/create`,companyData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
      );
      return response.data;
    } catch (error) {
      throw error;
     
    }
  };

  
  export const UpdateCompanyDetails = async (companyData) => {
    try {
      const response = await axios.post( API_BASE_URL1 +`company/update`,companyData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
   
  }
};
export const getCompanyById = async (id) => {
  try {
    const response = await axios.get(API_BASE_URL1 + `company/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'responsebyid')
    return response;
  } catch (error) {
    throw error
    // console.log(error)
  }
};